const menu = [
    {
        label: 'Booking',
        icon: 'pi pi-fw pi-home',
        to: '/dashboard',
        items: [
            {
                label: 'Booking',
                icon: 'pi pi-fw pi-home',
                to: '/dashboard'
            },
            {
                label: 'Kalendar',
                icon: 'pi pi-fw pi-calendar',
                to: '/calendar'
            },
            // {
            //     label: 'Slobodni termini',
            //     icon: 'pi pi-fw pi-calendar',
            //     to: '/apartment'
            // },
            {
                label: 'Rezervacije',
                icon: 'pi pi-fw pi-book',
                to: '/booking'
            },
            {
                label: 'Vile',
                icon: 'pi pi-fw pi-building',
                to: '/house'
            },
            {
                label: 'Apartmani',
                icon: 'pi pi-fw pi-home',
                to: '/apartment'
            }
        ]
    },
    {
        label: 'Kalendar',
        icon: 'pi pi-fw pi-calendar',
        to: '/calendar'
    },
    // {
    //     label: 'Slobodni termini',
    //     icon: 'pi pi-fw pi-calendar',
    //     to: '/apartment'
    // },
    {
        label: 'Rezervacije',
        icon: 'pi pi-fw pi-book',
        to: '/booking'
    },
    {
        label: 'Vile',
        icon: 'pi pi-fw pi-building',
        to: '/house'
    },
    {
        label: 'Apartmani',
        icon: 'pi pi-fw pi-home',
        to: '/apartment'
    }
    // {
    //     label: 'Oprema apartmana',
    //     icon: 'pi pi-fw pi-tag',
    //     to: '/amenities'
    // },
    // {
    //     label: 'Specifikacija apartmana',
    //     icon: 'pi pi-fw pi-tags',
    //     to: '/apartmentamenities'
    // },
    // {
    //     label: 'Payments',
    //     icon: 'pi pi-fw pi-home',
    //     to: '/payments'
    // }
];
export default menu;
